var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "hub-header",
    class: {
      'is-fixed': _vm.fixed
    }
  }, [_c('div', {
    staticClass: "hub-header__inner"
  }, [_c('router-link', {
    staticClass: "hub-brand",
    attrs: {
      "to": "/",
      "title": _vm.fullName
    }
  }, [_c('svg', {
    staticClass: "hub-brand__mark",
    attrs: {
      "viewBox": "14 17 92 92",
      "aria-hidden": "true"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "16,78 60,100 60,107 16,85",
      "fill": "#002a47"
    }
  }), _c('polygon', {
    attrs: {
      "points": "104,78 60,100 60,107 104,85",
      "fill": "#00335a"
    }
  }), _c('polygon', {
    attrs: {
      "points": "16,78 60,56 104,78 60,100",
      "fill": "#003f67"
    }
  }), _c('polygon', {
    attrs: {
      "points": "16,60 60,82 60,89 16,67",
      "fill": "#0a5f90"
    }
  }), _c('polygon', {
    attrs: {
      "points": "104,60 60,82 60,89 104,67",
      "fill": "#096aa0"
    }
  }), _c('polygon', {
    attrs: {
      "points": "16,60 60,38 104,60 60,82",
      "fill": "#0c78b3"
    }
  }), _c('polygon', {
    attrs: {
      "points": "16,42 60,64 60,71 16,49",
      "fill": "#2aa6e0"
    }
  }), _c('polygon', {
    attrs: {
      "points": "104,42 60,64 60,71 104,49",
      "fill": "#38b4ec"
    }
  }), _c('polygon', {
    attrs: {
      "points": "16,42 60,20 104,42 60,64",
      "fill": "#4ec8ff"
    }
  }), _c('ellipse', {
    attrs: {
      "cx": "60",
      "cy": "42",
      "rx": "9",
      "ry": "4.5",
      "fill": "#fff"
    }
  })]), _c('span', {
    staticClass: "hub-brand__text"
  }, [_c('b', [_vm._v("M3D HUB")]), _c('small', [_vm._v("Monolithic 3D Semiconductor Hub")])])]), _c('nav', {
    staticClass: "hub-gnb",
    attrs: {
      "aria-label": "주요 메뉴"
    }
  }, [_vm._l(_vm.menus, function (item) {
    return [item.disabled ? _c('span', {
      key: item.key,
      staticClass: "hub-gnb__item is-disabled",
      attrs: {
        "title": item.hint
      }
    }, [_vm._v(_vm._s(item.name)), item.badge ? _c('em', [_vm._v(_vm._s(item.badge))]) : _vm._e()]) : _c('a', {
      key: item.key,
      staticClass: "hub-gnb__item",
      class: {
        'is-active': item.active
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.go(item);
        }
      }
    }, [_vm._v(_vm._s(item.name))])];
  })], 2), _c('div', {
    staticClass: "hub-header__right"
  }, [_vm.user ? [_c('button', {
    staticClass: "hub-user",
    attrs: {
      "type": "button",
      "title": "마이페이지"
    },
    on: {
      "click": function ($event) {
        return _vm.go({
          path: '/account/mypage'
        });
      }
    }
  }, [_c('span', {
    staticClass: "hub-user__avatar"
  }, [_vm._v(_vm._s(_vm.initial))]), _c('span', {
    staticClass: "hub-user__name"
  }, [_vm._v(_vm._s(_vm.user.name))]), _c('span', {
    staticClass: "hub-user__role"
  }, [_vm._v(_vm._s(_vm.roleLabel))])]), _c('button', {
    staticClass: "hub-btn hub-btn--ghost",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("로그아웃")])] : [_c('button', {
    staticClass: "hub-btn hub-btn--ghost hub-only-wide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.go({
          path: '/account/signup'
        });
      }
    }
  }, [_vm._v("회원가입")]), _c('button', {
    staticClass: "hub-btn hub-btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.go({
          path: '/account/login'
        });
      }
    }
  }, [_vm._v("로그인")])], _c('button', {
    staticClass: "hub-menu-btn",
    class: {
      'is-open': _vm.mobileOpen
    },
    attrs: {
      "type": "button",
      "aria-expanded": _vm.mobileOpen ? 'true' : 'false'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.mobileOpen = !_vm.mobileOpen;
      }
    }
  }, [_c('i'), _vm._v("메뉴")])], 2)], 1), _vm.mobileOpen ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.closeMobile,
      expression: "closeMobile"
    }],
    staticClass: "hub-mobile"
  }, [_vm._l(_vm.menus, function (item) {
    return [item.disabled ? _c('span', {
      key: item.key,
      staticClass: "hub-mobile__item is-disabled"
    }, [_vm._v(_vm._s(item.name)), item.badge ? _c('em', [_vm._v(_vm._s(item.badge))]) : _vm._e()]) : _c('a', {
      key: item.key,
      staticClass: "hub-mobile__item",
      class: {
        'is-active': item.active
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.go(item);
        }
      }
    }, [_vm._v(_vm._s(item.name))])];
  }), _c('div', {
    staticClass: "hub-mobile__foot"
  }, [_vm.user ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.go({
          path: '/account/mypage'
        });
      }
    }
  }, [_vm._v("마이페이지")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v("로그아웃")])] : [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.go({
          path: '/account/login'
        });
      }
    }
  }, [_vm._v("로그인")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.go({
          path: '/account/signup'
        });
      }
    }
  }, [_vm._v("회원가입")])]], 2)], 2) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }